module.exports = __webpack_public_path__ + "static/media/Girl.e9121ae4.svg";